<template>
  <upsell-card
    :offer="offer"
    :currency="currency"
    :index="index"
    :count="count"
    :options="options"
    :title="title"
    :lead="lead"
    :agree="agree"
    @apply="$emit('apply')"
  />
</template>

<script>
import UpsellCard from './UpsellCardComponent'

export default {
  name: 'upsell-card-lt',
  components: {
    UpsellCard
  },
  props: {
    currency: {
      required: true
    },
    index: {
      required: true
    },
    count: {
      required: true
    },
    offer: {
      required: true
    }
  },
  data () {
    return {
      product: null
    }
  },
  computed: {
    segment () {
      return this.offer.segmentCode
    },
    translations () {
      return {
        title: {
          1: this.$pgettext('offer_card', 'You have an unused loan of'),
          2: this.$pgettext('offer_card', 'You now have the opportunity to apply for additional loan at significantly lower rates')
        },
        lead: {
          1: this.$pgettext('offer_card', 'We will pay the loan to your account as soon as you sign the contract'),
          2: this.$pgettext('offer_card', 'Check your pre-filled application and ask for a loan offer')
        },
        interestValue: {
          2: this.$pgettext('offer_card', 'segment.2.interest.value')
        },
        maturityValue: {
          2: this.$pgettext('offer_card', 'segment.2.maturity.value')
        },
        interest: this.$pgettext('offer_card', 'Interest rate'),
        maturity: this.$pgettext('offer_card', 'Maturity'),
        choose: this.$pgettext('offer_card', 'Choose a Product')
      }
    },
    options () {
      return [{
        title: this.translations.interest,
        value: this.interestValue,
        visible: this.interestValue
      }, {
        title: this.translations.maturity,
        value: this.maturityValue,
        visible: this.maturityValue
      }]
    },
    agree () {
      return null
    },
    title () {
      return this.translations.title[this.segment]
    },
    lead () {
      return this.translations.lead[this.segment]
    },
    interestValue () {
      if ([1, 2].includes(this.segment)) {
        return this.translations.interestValue[this.segment]
      }
      return null
    },
    maturityValue () {
      if ([1, 2].includes(this.segment)) {
        return this.translations.maturityValue[this.segment]
      }
      return null
    }
  }
}
</script>
